import React, { useState } from 'react';
import { CheckButton, CheckButtonFontStyle, CheckButtonStyle } from '../CheckButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { DemoPage } from './common/DemoLayout';

export const CheckButtonDemo: React.FC = () => {
    const [selected, setSelected] = useState(false);
    const [smallSelected, set_smallSelected] = useState(false);
    const [largeSelected, set_largeSelected] = useState(false);
    const [plainSelected, set_plainSelected] = useState(false);

    return (
        <DemoPage title='Check Button :'>
            <CheckButton
                id='save-budget'
                fontStyle={CheckButtonFontStyle.Small}
                label='CheckButton Demo with icon'
                icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
                selected={selected}
                onToggle={() => setSelected(!selected)}
                width='300px'
                height='60px'
            />
            <CheckButton
                id='checkButtonDemoSmall'
                fontStyle={CheckButtonFontStyle.Small}
                label='Small font style'
                selected={smallSelected}
                onToggle={() => set_smallSelected(!smallSelected)}
                width='180px'
            />
            <CheckButton
                id='checkButtonDemoLarge'
                fontStyle={CheckButtonFontStyle.Large}
                label='Large font style'
                selected={largeSelected}
                onToggle={() => set_largeSelected(!largeSelected)}
                width='180px'
            />
            <CheckButton
                id='checkButtonDemoPlain'
                fontStyle={CheckButtonFontStyle.Small}
                checkButtonStyle={CheckButtonStyle.Plain}
                label='Plain style'
                selected={plainSelected}
                onToggle={() => set_plainSelected(!plainSelected)}
            />
        </DemoPage>
    );
};
